export const payments = {
  subscription: {
    cancelAnytime: "Cancel anytime",
    cancelAnytimeAdditionalPurchase:
      "Cancel anytime. Some content requires additional purchase.",
    yearlyPromoPricing:
      "$49 per year for 1 year, then $69 per year after. Cancel anytime.",
    confirmYourPayment: "Start membership",
    confirmGiftCardPayment: "Buy now",
    lockedPages: "Locked pages",
    subscriptionDeclined:
      "There was a problem completing your subscription purchase",
    signUpToComplete: "Next",
    almostThereSignUp: "Almost there! Sign up to get started.",
    almostThereLogin: "Almost there! Log in to get continue.",
    subscribeToGlobalComixGold: "Subscribe to GlobalComix Gold",
    step2: "Step 2",
    applyPromoToComplete: "Apply your promo code to complete your purchase",
    purchasing: "Completing purchase",
    giftDelivery: "The gift card will be emailed to you.",
    exploreMoreContent: "No thanks, explore more content",
    buyGold: "Get gold",
    manageSubscription: "Manage subscription",
  },
  promoCode: {
    enterPromoCode: "Enter promo code",
    apply: "Apply",
    enterAnotherPromoCode: "Enter another promo code",
    applied: "applied",
    cannotBeUsed: "cannot be used",
  },
  donate: {
    donateToCreator: "Donate to creator",
    donate: "Donate",
    creator: "Creator",
    monthlyGoal: "Monthly goal",
    amountToDonate: "Enter amount to donate (${{minDonation}} minimum)",
    helpFund: "Help fund the creator for their time and work",
    supporterBadge: "Get a Supporter badge on your avatar sitewide",
    earlyAccess: "Get early access to new releases",
    repeatMonthly: "Repeat monthly",
    becomeASuperfan:
      "Become a super-fan and repeat this donation amount at the start of every month",
    donationSuccess: "Donation successful!",
    donationDeclined: "There was a problem completing your donation",
    minimumValue: "Minimum value for this field is: 3",
    wellDoneYouSuccessfullyDonated:
      "Well done! You successfully \n donated to {{artistName}}",
    makeAnotherDonation: "Make another donation",
    imAllSet: "I'm all set",
  },
  pdf: {
    digitalDownload: "Digital download (DRM-FREE)",
    guaranteedAccess: "Guaranteed access",
    toOnlineReading: "to online reading of this release, forever",
    unlimitedDownloadAvailability: "Unlimited download availability",
    ownerDeletesBooks: " - even if the owner deletes their books",
    purchaseRelease: "Purchase release",
    purchaseReleaseFor: "Purchase release for",
    pagesPDF: "page PDF",
    purchaseSuccess: "Purchase successful!",
    purchaseError: "There was an error with your purchase",
    successYouCanNowDownload:
      "Success! You can now download and read your release.",
    downloadYourRelease: "Download your release",
    minimumAmount: "Minimum amount: ",
    minimum: "Minimum: ",
    enterAmountYouWantToPay:
      "Enter amount you want to pay ({{minPrice}} minimum)",
  },
  payments: {
    expires: "Expires",
    newCardNumber: "New card number",
  },
  purchaseRelease: {
    unlockRelease: "Unlock release",
    pages: "pages",
    purchaseDecline: "There was a problem completing your purchase",
    purchaseSuccess: "Purchase successful!",
    thisIssueIsCollectible:
      "This issue is a Collectible and must be bought in order to be read.",
    youPurchasedThis: "You purchased this",
    collectibleIssue: "Collectible issue — purchase required to read.",
    claimableMonthlyReward:
      "This is part of this month's Gold rewards — claim it for free.",
  },
  prePaywall: {
    buyTheBookToContinueReading: "Buy the book to continue reading",
    becomeAMember: "Become a member",
    buy: "Buy {{price}}",
    orPayFullPrice: "or pay full price",
    forNoMembers: "{{price}} for non-members",
    withGoldMembership: "{{price}} with Gold membership",
    notAvailableWithoutGoldMembership: "Not available without Gold membership",
    unRestrictedAccessOnlineReading:
      "Unrestricted access to online reading of this release",
    supportTheCreators:
      "Support the creators - up to 70% of your purchase goes directly to creators",
    getBookFreeWithGold:
      "Get this book free with a Gold Membership to continue reading",
    freeWithGoldMembership: "Free with Gold membership",
    free: "Free",
  },
  bundles: {
    buyBundleNow: "Buy Now",
  },
  bundleSelection: {
    title: "Welcome to GlobalComix!",
    subtitle: "Choose a free gift on us!",
    subscribe: "Subscribe",
    valueLabel: "{{value}} value",
    bookCount: "{{count}} books",
    pageCount: "{{count}} pages",
  },
  pod: {
    physicalEdition: "Physical Edition",
    buyPhysicalEdition: "Buy Physical Edition",
    shippingAddress: "Shipping Address",
    payment: "Payment",
    confirmation: "Confirmation",
    firstName: "First name",
    lastName: "Last name",
    addressLine1: "Address line 1",
    addressLine2: "Address line 2 (optional)",
    city: "City",
    state: "State/Province",
    zip: "ZIP/Postal code",
    country: "Country",
    phoneNumber: "Phone number (optional)",
    continueToPayment: "Continue to Payment",
    paymentMethod: "Payment Method",
    shippingTo: "Shipping to",
    completePurchase: "Complete Purchase",
    editShippingAddress: "Edit shipping address",
    purchaseComplete: "Purchase Complete!",
    yourOrderHasBeenPlaced: "Your order has been placed successfully",
    youWillReceiveAnEmailConfirmationShortly:
      "You will receive an email confirmation shortly.",
    estimatedDelivery: "Estimated delivery: 2-3 weeks",
    physicalEditionOf: "Physical edition of",
    done: "Done",
    useSavedAddress: "Use saved address",
    orEnterNewAddress: "Or enter a new address",
    rememberThisAddress: "Remember this address",
    product: "Product",
    shipping: "Shipping",
    taxes: "Taxes",
    total: "Total",
    errors: {
      firstName: "First name is required",
      lastName: "Last name is required",
      address: "Address is required",
      city: "City is required",
      zip: "ZIP/Postal code is required",
      country: "Country is required",
      purchaseFailed: "There was a problem completing your purchase",
      taxShippingFailed: "Unable to calculate shipping and taxes",
      missingProductInfo: "Product information is missing",
    },
  },
};
